module.exports = __webpack_public_path__ + "img/tron (75).a37c4b6d.jpg";